import { logoutApiV1AuthLogoutPost } from '@/common/api/client/sdk.gen'
import type { LogoutApiV1AuthLogoutPostResponse } from '@/common/api/client/types.gen'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { removeHeaderToken } from '@/common/lib/fetch'
import { ROUTES } from '../lib/constants'

export type LogoutOptions = {
    redirect?: string
    email?: string
    noRedirect?: boolean
}

export const useLogout = (options?: LogoutOptions) => {
    const queryClient = useQueryClient()
    const navigate = useNavigate()
    const { redirect, email, noRedirect } = options ?? {}

    return useMutation<LogoutApiV1AuthLogoutPostResponse, Error>({
        mutationFn: () => logoutApiV1AuthLogoutPost().then(r => r.data!),
        onSuccess: () => {
            removeHeaderToken()
            queryClient.clear()
            if (redirect) {
                const searchParams = new URLSearchParams({ redirect })
                if (email) searchParams.set('email', email)
                navigate(`${ROUTES.AUTH.LOGIN}?${searchParams.toString()}`)
                return
            }
            if (noRedirect) return
            navigate(ROUTES.AUTH.LOGIN)
        },
    })
}
